import { useState, useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import Popup from "../../common/modal/Popup";
import { useNavigate, Link } from "react-router-dom";
import Loader from "../../common/loader/Loader";
const DeleteWardPopup = ({
  alertRec,
  onHide,
  alertModalShow,
  setAlertModalShow,
}) => {
  const [isAction, setIsAction] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const hideHandlerRes = () => {
    setIsAction(false);
    setIsDone(false);
    navigate("/");
  };

  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={alertModalShow}
        title={"Alert"}
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => onHide()}
            >
              Ok
            </Button>
          </>
        }
      >
        <div style={{ textAlign: "center" }}>
          <Alert variant={"danger"}>
            {"You are not authorised to perform this activity."}
          </Alert>
        </div>
      </Popup>
    </>
  );
};

export default DeleteWardPopup;
